import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import AppFooter from "../components/AppFooter";

export default function DisclaimerPage() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "General Information",
      content: `This Disclaimer applies to www.aicahealth.com, mobile applications, web applications, and all AICA Health digital platforms. It explains how information is collected, presented, and used across the platform.`,
    },

    {
      title: "Medical Disclaimer",
      content: `AICA Health, owned by AICA Healthtech Pvt Ltd, does not provide clinical diagnosis, emergency care, prescriptions, or direct treatment. All AI-generated outputs and health insights are informational and assistive only.`,
    },

    {
      title: "Doctor–Patient Relationship",
      content: `The platform is designed to support and strengthen the doctor-patient and caregiver-patient relationship, not replace professional medical consultation or licensed healthcare judgment.`,
    },

    {
      title: "Trademark & Intellectual Property",
      content: `The AICA Health logo, branding, software systems, AI models, and platform assets are intellectual property of AICA Healthtech Pvt Ltd and may not be copied, reproduced, or used without written permission.`,
    },

    {
      title: "Service Availability",
      content: `AICA Health services may be subject to local laws, regulations, and healthcare policies. Certain services may not be available in specific regions or jurisdictions.`,
    },

    {
      title: "Restricted Medications",
      content: `AICA Health does not endorse DEA-controlled substances, non-therapeutic drugs, or medications with potential misuse risks. The platform reserves the right to deny services in suspicious or non-compliant situations.`,
    },

    {
      title: "Subscription & Benefits",
      content: `Users may access health plans, digital wellness programs, preventive healthcare services, and subscription-based benefits through the platform subject to applicable terms and policies.`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow Effects */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/30 rounded-full blur-3xl"></div>

      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      {/* Main Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-12">

          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/70 border border-cyan-200 backdrop-blur-xl text-cyan-700 shadow-lg">
            <ShieldAlert size={18} />
            AICA HEALTH DISCLAIMER
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-slate-800">
            Disclaimer
          </h1>

          <p className="mt-4 max-w-3xl mx-auto text-slate-600 text-sm sm:text-base leading-relaxed">
            Important information regarding platform usage, medical limitations,
            healthcare support systems, and legal responsibilities associated
            with AICA Health services.
          </p>
        </div>

        {/* Disclaimer Sections */}
        <div className="grid gap-6">

          {sections.map((section, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:bg-white/70 transition-all duration-300 hover:scale-[1.01]"
            >

              {/* Card Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent pointer-events-none"></div>

              <div className="relative z-10">
                <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">
                  {section.title}
                </h2>

                <p className="text-slate-600 leading-relaxed text-sm sm:text-base">
                  {section.content}
                </p>
              </div>
            </div>
          ))}

        </div>

        {/* Subscription Section */}
        <div className="mt-10 rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8">

          <h2 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-4">
            Subscribe for Health Benefits
          </h2>

          <p className="text-slate-600 leading-relaxed text-sm sm:text-base max-w-3xl">
            Access exclusive preventive healthcare plans, AI-powered wellness
            monitoring, digital healthcare services, and annual subscription
            discounts designed for smarter health management.
          </p>

          {/* Future CTA */}
          {/*
          <button
            onClick={() => navigate("/payment")}
            className="mt-6 bg-cyan-600 text-white px-6 py-3 rounded-2xl font-semibold shadow-lg hover:bg-cyan-700 transition"
          >
            Subscribe Now
          </button>
          */}
        </div>

        {/* Footer */}
       <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
       
               </div>
                {/* <AppFooter /> */}

      </div>
    </div>
  );
}